import React, { useState, useRef, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { useFormStore } from '../../state/FormStore';

export function Zonwering({ verandaSize, verandaColor, opaalTexture, playTexture, verandaStartPosition, nodes, materials }) {
    //const { formData, getNumberOfGlassDoors } = useFormStore();
    const formData = useFormStore(state => state.formData.zonwering.zonwering_option);
    const [isExpanding, setIsExpanding] = useState(false);
    const cubeRef = useRef();
    const scaleXRef = useRef(0);

    const targetScaleX = 1;
    const speed = 0.005;

    useFrame(() => {
        if (isExpanding && scaleXRef.current < targetScaleX) {
            scaleXRef.current += speed;
            if (scaleXRef.current > targetScaleX) scaleXRef.current = targetScaleX;
        } else if (!isExpanding && scaleXRef.current > 0.1) {
            scaleXRef.current -= speed;
            if (scaleXRef.current < 0.1) scaleXRef.current = 0.1;
        }
        cubeRef.current.scale.z = scaleXRef.current;
    });

    useEffect(() => {
        if (formData) {
            setIsExpanding(true);
            const timeoutId = setTimeout(() => setIsExpanding(false), 2400); // Adjust the timeout as needed
            return () => clearTimeout(timeoutId);
        }
    }, [formData]);

    const handleClick = () => {
        setIsExpanding(!isExpanding);
    };

    return (
        <group onClick={handleClick}
            scale={[verandaSize[0], verandaSize[1], verandaSize[2]]}>
            <mesh
                castShadow
                receiveShadow
                onClick={handleClick}
                geometry={nodes.play_roof.geometry}>
                <meshStandardMaterial attach="material" map={playTexture} transparent opacity={1} />
            </mesh>

            <group name="zonwering_roof">
                <mesh
                    ref={cubeRef}
                    castShadow
                    receiveShadow
                    geometry={nodes.Cube.geometry}
                    material={nodes.Cube.material}
                    position={[0, 0.522, -0.213]}
                    scale={[1, 1, 1]}
                    rotation={[0.13, 0, 0]}
                >
                    <meshStandardMaterial attach="material" map={opaalTexture} color={"#353C40"} />
                </mesh>
            </group>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.zonwering_left_beam.geometry}
                material={nodes.zonwering_left_beam.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                scale={0.01}>
                <meshStandardMaterial attach="material" color={verandaColor[0]} />
            </mesh>
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.zonwering_right_beam.geometry}
                material={nodes.zonwering_right_beam.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                scale={0.01}>
                <meshStandardMaterial attach="material" color={verandaColor[0]} />
            </mesh>

            <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>

                <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes.zonwering_back_beam.geometry}
                    material={nodes.zonwering_back_beam.material}>
                    <meshStandardMaterial attach="material" color={verandaColor[0]} />
                </mesh>


            </group>
        </group>
    );
}

//useGLTF.preload('/veranda3/veranda3.glb');
